export const Theme = {
    colors: {
        skeletonBase: '#d5d5d5',
        skeletonHighlight: '#e3e1e1',
    }
}